export const APISettings = {
    headers: new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }),
    baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
};
